import type { OutboundAuthAPIResponse } from './types';

/**
 * Fetches outbound auth data for a given user
 * @param aaid - Atlassian Account ID
 * @returns Promise<OutboundAuthAPIResponse > - The API response
 */
export const fetchOutboundAuthData = async (aaid: string): Promise<OutboundAuthAPIResponse> => {
	const response = await fetch(`/gateway/api/outbound-auth/aaId/${aaid}`, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
		},
	});

	if (!response.ok) {
		throw new Error('Failed to fetch outbound auth data');
	}

	return (await response.json()) as OutboundAuthAPIResponse;
};
